<template>
  <SingleTraining />
</template>

<script>
import SingleTraining from '@/components/content/education/EditViewSingleEducation.vue'

export default {
  name: 'ContentTrainingVerification',
  components: { SingleTraining }
}
</script>

<style scoped>

</style>
